<template>
  <div class="google-auth-bind">
    <div class="auth-container">
      <div class="auth-header">
        <h2 style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">
          Google Authenticator 绑定
        </h2>
      </div>

      <div v-if="!hasBound" class="auth-content">
        <div class="step-info">
          <p style="color: #666; margin-bottom: 20px; line-height: 1.6;">
            请使用 Google Authenticator 应用扫描下方二维码，完成双重验证绑定
          </p>
        </div>

        <div class="qrcode-section" v-if="showQRCode">
          <div class="qrcode-container">
            <canvas
                id="qrcode-canvas"
                class="qrcode-image"
            ></canvas>
          </div>
          <p class="qrcode-tip">使用 Google Authenticator 扫描此二维码</p>
        </div>

        <div v-else-if="loading" class="loading-section">
          <Spin size="large" fix>
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>正在获取二维码...</div>
          </Spin>
        </div>

        <div v-else-if="error" class="error-section">
          <Alert type="error" show-icon>
            获取二维码失败
            <template slot="desc">{{ error }}</template>
          </Alert>
          <Button type="primary" @click="getAuthStatus" style="margin-top: 15px;">
            重新获取
          </Button>
        </div>

        <div class="manual-key" v-if="secretKey">
          <p style="color: #999; font-size: 12px; margin-bottom: 8px;">
            如果无法扫描二维码，请手动输入以下密钥：
          </p>
          <div class="key-display">
            <span>{{ secretKey }}</span>
            <Button type="text" size="small" @click="copySecretKey" style="margin-left: 10px;">
              <Icon type="md-copy"/>
              复制
            </Button>
          </div>
        </div>

        <div class="action-buttons">
          <Button type="primary" @click="refreshQRCode" :loading="loading">
            <Icon type="md-refresh"/>
            刷新二维码
          </Button>
        </div>

        <div class="action-buttons">
          <Button type="success" @click="$router.go(-1)" :loading="loading" style="margin-left: 1rem">
            我已完成扫码，点击返回
          </Button>
        </div>
      </div>

<!--      <div v-else class="bound-status">-->
<!--        <div class="success-info">-->
<!--          <Icon type="md-checkmark-circle" color="#19be6b" size="48"/>-->
<!--          <h3 style="color: #19be6b; margin: 15px 0 10px;">已绑定 Google Authenticator</h3>-->
<!--          <p style="color: #666; margin-bottom: 20px;">-->
<!--            您的账号已成功绑定双重验证，请妥善保管您的验证器设备-->
<!--          </p>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import {google2afStatus, agreeBound} from '@/api/totp'
import {mapGetters} from "vuex";
import QRCode from 'qrcode';

export default {
  name: "GoogleAuthBind",
  data() {
    return {
      hasBound: false, // 是否已绑定
      secretKey: "", // 手动输入密钥
      loading: false, // 加载状态
      error: "", // 错误信息
      allowSkip: true, // 是否允许跳过绑定
      showQRCode: false, // 控制二维码显示的关键变量
      qrCodeData: "" // 实际用于生成二维码的数据
    };
  },
  computed: {
    ...mapGetters(['token', 'userInfo'])
  },
  mounted() {
    this.getAuthStatus();
  },
  methods: {
    // 获取认证状态
    async getAuthStatus() {
      this.loading = true;
      this.error = "";
      this.showQRCode = false; // 重置显示状态

      try {
        const response = await google2afStatus(this, {token: this.token === 'undefined' ? '' : this.token});
        console.log('response', response)

        if (response.code === 1) {
          this.hasBound = response.data.hasBound;
          if (!this.hasBound && response.data.qrCodeUrl) {
            this.secretKey = response.data.secretKey;
            this.qrCodeData = response.data.qrCodeUrl;
            console.log('qrCodeData:', this.qrCodeData);

            // 💡 关键：设置 showQRCode = true，将 <canvas id="qrcode-canvas"> 渲染到 DOM 中
            this.showQRCode = true;

            // 等待DOM更新后生成二维码
            this.$nextTick(() => {
              this.generateQRCode(this.qrCodeData);
            });
          } else {
            // 如果已绑定或无URL，确保隐藏二维码区域
            this.showQRCode = false;
          }
        } else {
          this.error = response.msg || '获取认证状态失败';
        }
      } catch (err) {
        this.error = '网络请求失败，请稍后再试';
      } finally {
        this.loading = false;
      }
    },
    async generateQRCode(qrText) {
      console.log('开始生成二维码，内容:', qrText);

      if (!qrText) {
        console.error('二维码内容为空');
        return;
      }

      const canvas = document.getElementById('qrcode-canvas');

      if (!canvas) {
        // 如果 Canvas 找不到，可能是 DOM 渲染失败，但我们已经用 $nextTick 避免了
        this.error = 'Canvas 元素未找到，请检查 DOM 结构。';
        return;
      }

      try {
        // 清除 canvas (可选，但良好习惯)
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // 使用您已验证成功的 QRCode.toCanvas API
        await QRCode.toCanvas(canvas, qrText, {
          width: 200,
          height: 200, // 确保尺寸一致
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          },
          errorCorrectionLevel: 'M' // 错误级别设置为 M
        });

        // 成功渲染，无需再设置 this.showQRCode = true，因为它已经在 getAuthStatus 中设置了
        console.log('二维码渲染成功');
      } catch (err) {
        console.error('渲染二维码失败:', err);
        // 如果渲染失败，显示错误信息并隐藏二维码区域
        this.error = '二维码生成失败，请刷新重试。' + err.message;
        this.showQRCode = false;
      }
    },

    async refreshQRCode() {
      // 如果数据存在，直接刷新
      if (this.qrCodeData) {
        await this.generateQRCode(this.qrCodeData);
        if (!this.error) { // 只有在没有渲染错误时才显示成功
          this.$Message.success('二维码已刷新');
        }
      } else {
        // 如果数据不存在，重新获取状态
        await this.getAuthStatus();
      }
    },
    // 复制密钥
    copySecretKey() {
      if (!this.secretKey) return;

      // 使用现代浏览器的 Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.secretKey).then(() => {
          this.$Message.success('密钥已复制到剪贴板');
        }).catch(() => {
          this.fallbackCopyText(this.secretKey);
        });
      } else {
        this.fallbackCopyText(this.secretKey);
      }
    },

    // 兼容旧浏览器的复制方法
    fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        this.$Message.success('密钥已复制到剪贴板');
      } catch (err) {
        this.$Message.error('复制失败，请手动复制');
      }

      document.body.removeChild(textArea);
    },

    // 跳过绑定
    handleSkip() {
      this.$Modal.confirm({
        title: '跳过绑定确认',
        content: '跳过绑定将无法使用双重验证功能，建议尽快完成绑定以增强账号安全性。确定要跳过吗？',
        onOk: () => {
          this.$Message.info('您可以选择稍后在安全设置中完成绑定');
          // 实际项目中可能需要调用跳过接口或跳转到其他页面
        }
      });
    },
  }
}
</script>

<style scoped lang="less">
.google-auth-bind {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 400px;
  padding: 20px;

  .auth-container {
    width: 100%;
    max-width: 500px;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 30px;
  }

  .auth-header {
    text-align: center;
    margin-bottom: 20px;
  }

  .qrcode-section {
    text-align: center;
    margin: 25px 0;

    .qrcode-container {
      display: inline-block;
      padding: 15px;
      background: #f8f8f9;
      border-radius: 6px;
      border: 1px solid #dcdee2;

      .qrcode-image {
        width: 200px;
        height: 200px;
        display: block;
      }
    }

    .qrcode-tip {
      color: #999;
      font-size: 14px;
      margin-top: 15px;
    }
  }

  .loading-section,
  .error-section {
    text-align: center;
    margin: 40px 0;
  }

  .manual-key {
    margin: 20px 0;
    padding: 15px;
    background: #f8f8f9;
    border-radius: 6px;

    .key-display {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: 'Courier New', monospace;
      font-weight: bold;
      color: #515a6e;
      background: white;
      padding: 10px 15px;
      border-radius: 4px;
      border: 1px solid #dcdee2;
    }
  }

  .action-buttons {
    text-align: center;
    margin-top: 25px;
  }

  .bound-status {
    text-align: center;
    padding: 20px 0;

    .success-info {
      margin-bottom: 30px;
    }

    .bound-actions {
      margin-top: 20px;
    }
  }

  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }

  @keyframes ani-demo-spin {
    from {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}

@media (max-width: 768px) {
  .google-auth-bind {
    padding: 10px;

    .auth-container {
      padding: 20px 15px;
    }

    .qrcode-section .qrcode-container .qrcode-image {
      width: 180px;
      height: 180px;
    }
  }
}
</style>